// TODO: remove tab state and update demand on conversation obj (open and history)

export const setTicketFiles = (data) => {
  return {
    type: 'SET_PICTURES',
    payload: { data },
  }
}
